import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { usuarioLogueado } from './utils/loggedInfo';
import CustomLoader from './components/common/CustomLoader';
import Layout from './components/Layout';
import history from './utils/history';
import waitFor from './utils/waitFor';

const AccountRouter = lazy(() => import('./components/Account'));
const InicioRouter = lazy(() => import('./components/Inicio'));
const AdministracionRouter = lazy(() => import('./components/Administracion'));
const CrmRouter = lazy(() => import('./components/Crm'));
const VentasRouter = lazy(() => import('./components/Ventas'));
const Configuracion = lazy(() => import('./components/Configuracion'));
const Tablero = lazy(() => import('./components/Tablero'));
const Reportes = lazy(() => import('./components/Reportes'));

const listofPages = [
  '/login',
  '/verificar-usuario',
  '/solicitar-cambiar-contrasena',
  '/cambiar-contrasena',
];

const Routes = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/';
  const timeout = { enter: 500, exit: 500 };
  const animationName = 'rag-fadeInLeft';

  if (listofPages.indexOf(location.pathname) > -1) {
    return (
      <Suspense fallback={<CustomLoader />}>
        <Switch location={location}>
          <Route path={'/'} component={AccountRouter} />
        </Switch>
      </Suspense>
    );
  } else {
    return (
      <>
        {usuarioLogueado() ? (
          <Layout>
            <TransitionGroup>
              <CSSTransition
                key={currentKey}
                timeout={timeout}
                classNames={animationName}
                exit={false}
              >
                <Suspense fallback={<CustomLoader />}>
                  <Switch location={location}>
                    <Route exact path='/inicio' component={InicioRouter} />
                    <Route
                      path='/administracion'
                      component={AdministracionRouter}
                    />
                    <Route
                      path='/crm'
                      component={CrmRouter}
                    />
                    <Route
                      path='/ventas'
                      component={VentasRouter}
                    />
                    <Route
                      path='/configuracion'
                      component={Configuracion}
                    />
                    <Route path={'/tablero'} render={waitFor(Tablero)} />
                    <Route path={'/reportes'} render={waitFor(Reportes)} />
                    <Redirect from='**' to='/inicio' />
                  </Switch>
                </Suspense>
              </CSSTransition>
            </TransitionGroup>
          </Layout>
        ) : (
          <Redirect to="/login" />
        )}
      </>
    );
  }
};

export default withRouter(Routes);
